import React from "react";
import { GenerateAudioFilesModalTemplate } from "themes/administration/content-sync/components";

function GenerateAudioFilesModal(props) {
    return <GenerateAudioFilesModalTemplate {...props} />;
}

export default GenerateAudioFilesModal;
